import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import NehaHeadshot from './assets/neha_headshot.png';
import SauravHeadshot from './assets/saurav_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'Band Score', score: 8.5, scoreIncrease: 'Academic' }
          ]}
          studentAvatar={SauravHeadshot}
          studentName="Saurav"
          style={{ height: '100%' }}
        >
          I am a busy professional, so I wanted to get the most of my 2 hour night study sessions. Your interface is spectacular. The number of practice sets provided is enormous. One can keep practicing and getting better at it, and they won't run out. I think your course was an essential factor in getting a good score in the IELTS, and I would recommend it to all.
        </QuoteCardWithScoreImprovements>
      </div>

      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'Band Score', score: 8.5, scoreIncrease: 'General Training' }
          ]}
          studentAvatar={NehaHeadshot}
          studentName="Neha"
          style={{ height: '100%' }}
        >
          The listening & reading tests available on the Magoosh platform helped me to get my best score. I used these tests regularly to practice & this helped me score a 9 in reading & listening. The lessons available for other topics gave a lot of input about the minute details that we usually miss in speaking & writing.
        </QuoteCardWithScoreImprovements>
      </div>
    </div>
  );
};
